/** 建筑 / 楼层（设计文档 entities/building.ts）。 */
export interface Building {
  readonly floors: number; // 楼层数
  readonly floorHeight: number; // 层间距（米）
  readonly lobbyFloor: number; // 大厅层
}

export function createBuilding(floors: number, floorHeight: number, lobbyFloor: number): Building {
  return { floors, floorHeight, lobbyFloor };
}
